"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReadContentButton = exports.QuestionPageContainer = exports.PillButton = exports.Label = exports.ScrollNavBar = exports.StyledArticleContent = exports.ScreenshotContainer = exports.ScreenshotPositionContainer = exports.ScrollContainer = exports.Screenshot = exports.ScreenshotLoadingContainer = exports.ScreenshotPopupContainer = exports.ContentTagSearch = exports.ContentTagModalContainer = exports.EyeIcon = exports.ScreenshotThumbnail = exports.StyledInfoColumn = exports.StyledTopSection = exports.StyledPageTitle = exports.StyledWidthContainer = exports.ParagraphText = exports.ParagraphLabel = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _knotchincWebReactComponents = require("@bit/knotchinc.web-react-components.styled");

var _knotchincWebReactComponents2 = require("@bit/knotchinc.web-react-components.content-count-block");

var _eyeIcon = _interopRequireDefault(require("./assets/eyeIcon.svg"));

var _circleDownArrow = _interopRequireDefault(require("./assets/circleDownArrow.svg"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16, _templateObject17, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ParagraphLabel = _styledComponents["default"].div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  font-weight: ", ";\n  display: inline-block;\n  ", "\n  font-size: 9px;\n  line-height: 17px;\n  color: ", ";\n  width: 20%;\n"])), function (_ref) {
  var theme = _ref.theme;
  return theme.fontWeights.bold;
}, _knotchincWebReactComponents.textLabel, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.palette[6];
});

exports.ParagraphLabel = ParagraphLabel;

var ParagraphText = _styledComponents["default"].div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  width: 80%;\n  vertical-align: top;\n  display: inline-block;\n  font-size: 16px;\n  line-height: 17px;\n  color: white;\n  text-overflow: ellipsis;\n  overflow: hidden;\n\n  .pageLink {\n    color: white;\n    width: 100%;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    text-decoration: none;\n    border-bottom: 1px solid;\n  }\n"])));

exports.ParagraphText = ParagraphText;

var StyledWidthContainer = _styledComponents["default"].div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  max-width: 1100px;\n  position: relative;\n  margin: auto;\n  transition: all 0.3s ease;\n  padding: ", ";\n\n  @media (min-width: 1300px) {\n    max-width: 1200px;\n  }\n\n  @media (min-width: 1500px) {\n    max-width: 1400px;\n  }\n\n  @media (min-width: 1700px) {\n    max-width: 1600px;\n  }\n"])), function (_ref3) {
  var padding = _ref3.padding;
  return padding || '0px 100px';
});

exports.StyledWidthContainer = StyledWidthContainer;

var StyledPageTitle = _styledComponents["default"].div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  font-weight: 100;\n  font-size: 24px;\n  letter-spacing:0.02em;\n  color: white;\n  margin-bottom: 50px;\n\n  @media (min-width: 1300px) {\n    font-size: 24px;\n  }\n\n  @media (min-width: 1500px) {\n    font-size: 27px;\n  }\n"])));

exports.StyledPageTitle = StyledPageTitle;

var StyledTopSection = _styledComponents["default"].div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  text-align: left;\n  padding-top: 40px;\n  color: white;\n"])));

exports.StyledTopSection = StyledTopSection;

var StyledInfoColumn = _styledComponents["default"].div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  position: relative;\n  overflow: hidden;\n  padding: ", ";\n  width: 45%;\n  display: inline-block;\n  vertical-align: top;\n  height: 100%;\n"])), function (_ref4) {
  var padding = _ref4.padding;
  return padding || '120px 60px 0 0';
});

exports.StyledInfoColumn = StyledInfoColumn;

var ScreenshotThumbnail = _styledComponents["default"].div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  text-align: center;\n  margin: auto;\n  border-radius: 20px;\n  background-color: ", ";\n  cursor: ", ";\n  background-image: ", ";\n  background-size: 100% auto;\n  position: relative;\n  transition: all .3s ", ";\n  box-shadow: 0 2px 20px 7px rgba(0,0,0,0.05);\n\n  &:hover {\n    transform: ", ";\n  }\n\n  &:active {\n    transform: ", ";\n  }\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    box-shadow: inset 0 -15px 20px 0px rgba(0, 0, 0, 0.02);\n  }\n"])), function (_ref5) {
  var colors = _ref5.theme.colors;
  return colors.palette[1];
}, function (_ref6) {
  var image = _ref6.image;
  return image ? 'pointer' : 'initial';
}, function (_ref7) {
  var image = _ref7.image;
  return "url(".concat(image, ")");
}, function (_ref8) {
  var transition = _ref8.theme.transition;
  return transition.bezier;
}, function (_ref9) {
  var image = _ref9.image;
  return image ? 'translateY(-2px) scale(1.01)' : '';
}, function (_ref10) {
  var image = _ref10.image;
  return image ? 'translateY(-2px) scale(1.02)' : '';
});

exports.ScreenshotThumbnail = ScreenshotThumbnail;

var EyeIcon = _styledComponents["default"].div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  position: absolute;\n  top: 50px;\n  right: -25px;\n  width: 50px;\n  background: ", " url(", ");\n  height: 50px;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 14px;\n  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.15);\n"])), function (_ref11) {
  var colors = _ref11.theme.colors;
  return colors.palette[7];
}, _eyeIcon["default"]);

exports.EyeIcon = EyeIcon;

var ContentTagModalContainer = _styledComponents["default"].div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 700px;\n  height: 350px;\n  padding: 20px;\n"])));

exports.ContentTagModalContainer = ContentTagModalContainer;

var ContentTagSearch = _styledComponents["default"].input(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  background: none;\n  border: 0;\n  border-bottom: 1px solid #cacaca;\n  line-height: 32px;\n  color: #585858;\n  font-family: Brandon;\n  width: 100%;\n  outline: none;\n  font-size: 12px;\n  padding: 0;\n  height: 32px;\n  text-indent: 14px;\n  margin-bottom: 40px;\n  width: 57%;\n"])));

exports.ContentTagSearch = ContentTagSearch;

var ScreenshotPopupContainer = _styledComponents["default"].div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  background: white;\n  height: 700px;\n  width: 1120px;\n  overflow: scroll;\n  transition: all .3s ", ";\n\n  @media (max-width: 1120px) {\n    width: 800px;\n  }\n\n  @media (max-width: 920px) {\n    width: 550px;\n  }\n"])), function (_ref12) {
  var transition = _ref12.theme.transition;
  return transition.bezier;
});

exports.ScreenshotPopupContainer = ScreenshotPopupContainer;

var ScreenshotLoadingContainer = _styledComponents["default"].div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  height: 100%;\n  width: 100%;\n  ", ";\n"])), _knotchincWebReactComponents.contentCentered);

exports.ScreenshotLoadingContainer = ScreenshotLoadingContainer;

var Screenshot = _styledComponents["default"].div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  width: 100%;\n  max-width: 1200px;\n  margin: auto;\n  opacity: ", ";\n  transition: all .3s ", ";\n  position: relative;\n"])), function (_ref13) {
  var opacity = _ref13.opacity;
  return opacity;
}, function (_ref14) {
  var transition = _ref14.theme.transition;
  return transition.bezier;
});

exports.Screenshot = Screenshot;

var ScrollContainer = _styledComponents["default"].div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  background: ", ";\n  min-height: 100%;\n  padding: 186px 160px;\n  top: 100%;\n  margin-top: -80px;\n  z-index: 1;\n  position: absolute;\n  left: 0;\n  right: 0;\n  ", ";\n\n  @media (min-height: 700px) {\n      margin-top: -120px;\n  }\n\n  @media (min-height: 900px) {\n      margin-top: -180px;\n  }\n"])), function (_ref15) {
  var palette = _ref15.theme.colors.palette;
  return palette[3];
}, _knotchincWebReactComponents.contentCentered);

exports.ScrollContainer = ScrollContainer;

var ScreenshotPositionContainer = _styledComponents["default"].div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 55%;\n  display: inline-block;\n  vertical-align: top;\n"])));

exports.ScreenshotPositionContainer = ScreenshotPositionContainer;

var ScreenshotContainer = _styledComponents["default"].div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: ", ";\n  transform: translate3d(0,0,0);\n  display: inline-block;\n  vertical-align: top;\n  will-change: transform;\n"])), function (_ref16) {
  var maxHeight = _ref16.maxHeight;
  return maxHeight || '1000px';
});

exports.ScreenshotContainer = ScreenshotContainer;

var StyledArticleContent = _styledComponents["default"].div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteral(["\n  max-width: 1000px;\n  margin: auto;\n  color: white;\n  text-align: left;\n  position: relative;\n\n  ", " {\n    color: white;\n    display: block;\n    margin-bottom: 32px;\n    margin-left:0;\n\n    font-weight: normal;\n    font-size: 10px;\n  }\n\n  .content {\n    line-height: 1.8;\n    text-indent: 32px;\n    font-weight: 100;\n    text-align: justify;\n\n    & > p:first-child {\n      margin-top: 0;\n    }\n  }\n\n  ", " {\n    padding-left: 25px;\n    float: right;\n    position: sticky;\n    top: 120px;\n    max-width: 20%;\n    font-size: 8px;\n    line-height: 11px;\n    letter-spacing: 1.44292px;\n    text-transform: uppercase;\n    color: #9FBDD6 !important;\n  }\n"])), _knotchincWebReactComponents2.ContentCount, _knotchincWebReactComponents2.ContentCountBlockContainer);

exports.StyledArticleContent = StyledArticleContent;

var ScrollNavBar = _styledComponents["default"].div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteral(["\n  width: 100%;\n  height: 80px;\n  color: white;\n  ", ";\n  text-align: left;\n  transition: all .3s ", ";\n  text-align: right;\n\n  ", " {\n    float: none;\n    white-space: nowrap;\n  }\n\n  ", " {\n    color: white;\n  }\n\n  @media (min-height: 700px) {\n    height: 120px;\n  }\n\n  @media (min-height: 900px) {\n    height: 180px;\n  }\n"])), _knotchincWebReactComponents.contentCentered, function (_ref17) {
  var transition = _ref17.theme.transition;
  return transition.bezier;
}, _knotchincWebReactComponents2.ContentCountBlockContainer, _knotchincWebReactComponents2.ContentCount);

exports.ScrollNavBar = ScrollNavBar;

var Label = _styledComponents["default"].div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteral(["\n  ", "\n  opacity: 0.5;\n  color: ", ";\n"])), _knotchincWebReactComponents.textLabel, function (_ref18) {
  var light = _ref18.light,
      theme = _ref18.theme;
  return light ? 'white' : theme.colors.darkGrey;
});

exports.Label = Label;

var PillButton = _styledComponents["default"].div(_templateObject20 || (_templateObject20 = _taggedTemplateLiteral(["\n  ", "\n  border: 1px solid white;\n  min-width: 89px;\n  color: white;\n  border-radius: 32px;\n  height: 32px;\n  text-align: center;\n  line-height: 32px;\n  padding: 0 16px;\n  transition: all .3s ", ";\n  cursor: pointer;\n\n  &:hover {\n    background: white;\n    color: ", ";\n  }\n"])), _knotchincWebReactComponents.textLabel, function (_ref19) {
  var transition = _ref19.theme.transition;
  return transition.bezier;
}, function (_ref20) {
  var palette = _ref20.theme.colors.palette;
  return palette[7];
});

exports.PillButton = PillButton;

var QuestionPageContainer = _styledComponents["default"].div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteral(["\n  z-index: 2;\n  ", ";\n"])), (0, _knotchincWebReactComponents.absFull)(0, 0, 'auto', 0));

exports.QuestionPageContainer = QuestionPageContainer;

var ReadContentButton = _styledComponents["default"].div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteral(["\n  background: url('", "');\n  background-repeat: no-repeat;\n  width: 12px;\n  height: 12px;\n  float: right;\n  background-size: 100%;\n"])), _circleDownArrow["default"]);

exports.ReadContentButton = ReadContentButton;

//# sourceMappingURL=styled.js.map